export default {
  'nav.home': 'Home',
  'nav.services': 'Services',
  'nav.about': 'About Us',
  'nav.booking': 'Book Appointment',
  'nav.call': 'Call Now',
  'nav.whatsapp': 'WhatsApp',

  'hero.badge': 'Van & Surrounding Districts · 24/7 Service',
  'hero.scroll': 'Scroll',
  'hero.slide1.title': 'Van\'s Trusted Plumber',
  'hero.slide1.sub': 'We work with a friendly team. The only address for quality.',
  'hero.slide2.title': 'We\'re Here for Every Plumbing Job',
  'hero.slide2.sub': 'From plumbing to natural gas, from boiler service to drain cleaning.',
  'hero.slide3.title': 'Fast & Lasting Solutions',
  'hero.slide3.sub': 'On time, meticulous and guaranteed workmanship. Serving Van and surrounding districts.',
  'hero.stat1.value': '15+',
  'hero.stat1.label': 'Years Experience',
  'hero.stat2.value': '3',
  'hero.stat2.label': 'Expert Masters',
  'hero.stat3.value': '500+',
  'hero.stat3.label': 'Completed Jobs',
  'hero.stat4.value': '24/7',
  'hero.stat4.label': 'Support',

  'services.badge': 'Professional Plumbing Services',
  'services.title': 'Featured',
  'services.highlight': 'Our Services',
  'services.subtitle': 'We provide reliable, fast and lasting plumbing solutions in Van and surrounding districts.',
  'services.viewAll': 'View All Services',
  'services.detail': 'Details',
  'services.callBtn': 'Call Now',

  'svc.1.title': 'Sanitary Plumbing',
  'svc.1.desc': 'Complete water plumbing, pipe laying and water leak detection services for homes and businesses.',
  'svc.2.title': 'Repair & Renovation Work',
  'svc.2.desc': 'Faucet, sink, toilet replacement, bathroom renovation and water plumbing renewal services.',
  'svc.3.title': 'Boiler Service & Radiator Cleaning',
  'svc.3.desc': 'Protect your heating system with boiler service, radiator cleaning and water tank repair.',
  'svc.4.title': 'Natural Gas Indoor Installation',
  'svc.4.desc': 'Pipe installation, bathroom renovation, gas leak detection and safety inspection.',
  'svc.5.title': 'Drain & Blockage Clearing',
  'svc.5.desc': 'We quickly solve sink, toilet and main line blockages with professional machines.',
  'svc.6.title': 'Faucet & Fixture Repair',
  'svc.6.desc': 'Faucet replacement and repair, mixer tap installation, water pressure adjustment services.',
  'svc.7.title': 'Fault Detection & Device Repair',
  'svc.7.desc': 'Non-destructive detection of water leaks, pressure drops and plumbing faults with special devices.',
  'svc.8.title': 'Cooperative & Site Work',
  'svc.8.desc': 'Apartment and site plumbing management, common area maintenance and fault planning.',
  'svc.9.title': 'Fire Systems',
  'svc.9.desc': 'Sprinkler and fire plumbing installation, fire safety systems maintenance.',

  'whyus.badge': 'Why Choose Us?',
  'whyus.title': 'Quality and Trust',
  'whyus.highlight': 'Together',
  'whyus.subtitle': 'Vanpolat Tesisat has been providing reliable service to thousands of customers in Van for years.',
  'feat.1.title': 'Guaranteed Workmanship',
  'feat.1.desc': 'All our plumbing work is guaranteed. Free intervention if problems occur.',
  'feat.2.title': 'Fast Response',
  'feat.2.desc': 'Same day in Van center, shortest time for districts.',
  'feat.3.title': 'Licensed & Insured',
  'feat.3.desc': 'All our masters are certified, work is done in an insured manner.',
  'feat.4.title': 'Affordable Price',
  'feat.4.desc': 'Market-competitive, transparent pricing. No hidden fees.',
  'feat.5.title': '24/7 Support',
  'feat.5.desc': 'You can reach us 24/7 via WhatsApp or phone for emergency repairs.',
  'feat.6.title': 'Professional Equipment',
  'feat.6.desc': 'Fast and non-destructive solutions with fault detection devices and modern equipment.',

  'team.badge': 'Our Team',
  'team.title': 'Expert',
  'team.highlight': 'Our Masters',
  'team.subtitle': 'Our experienced and friendly team is always by your side.',
  'team.more': 'More About Us',
  'team.role.1': 'Plumbing Master & Founder',
  'team.role.2': 'Plumbing Master',
  'team.role.3': 'Plumbing Master',
  'team.desc.1': 'Expert in sanitary plumbing and natural gas systems with over 15 years of experience.',
  'team.desc.2': 'Experienced master in boiler maintenance, radiator cleaning and renovation work.',
  'team.desc.3': 'Specialist in drain cleaning, fault detection and natural gas installation.',

  'cta.title': 'Do You Have a Plumbing Problem?',
  'cta.subtitle': 'Call us now, we\'ll be there as soon as possible. We serve 24/7 for emergency repairs.',

  'contact.badge': 'Contact',
  'contact.title': 'Get In',
  'contact.highlight': 'Touch With Us',
  'contact.subtitle': 'Fill in the form for your questions or call us directly — we\'ll get back to you shortly.',
  'contact.form.title': 'Send a Message',
  'contact.form.name': 'Full Name *',
  'contact.form.namePH': 'Your full name',
  'contact.form.phone': 'Phone *',
  'contact.form.phonePH': '+90 5XX XXX XXXX',
  'contact.form.email': 'Email',
  'contact.form.emailPH': 'example@email.com',
  'contact.form.serviceType': 'Service Type',
  'contact.form.selectPH': 'Select',
  'contact.form.message': 'Your Message *',
  'contact.form.messagePH': 'Briefly explain your plumbing problem or request...',
  'contact.form.submit': 'Send Message',
  'contact.form.sending': 'Sending...',
  'contact.success.title': 'Message Received!',
  'contact.success.sub': 'We will contact you as soon as possible.',
  'contact.success.back': 'Send Another Message',
  'contact.loc.label': 'Location',
  'contact.loc.value': 'Van and Surrounding Districts, Turkey',
  'contact.hours.label': 'Working Hours',
  'contact.hours.value': 'Every day 07:00 – 22:00 (Emergency: 24/7)',
  'contact.wa.label': 'WhatsApp',
  'contact.wa.value': '0507 607 4165',
  'contact.svc.0': 'Select',
  'contact.svc.1': 'Sanitary Plumbing',
  'contact.svc.2': 'Repair & Renovation',
  'contact.svc.3': 'Boiler Service & Radiator Cleaning',
  'contact.svc.4': 'Natural Gas Indoor Installation',
  'contact.svc.5': 'Drain Cleaning',
  'contact.svc.6': 'Faucet Repair',
  'contact.svc.7': 'Fault Detection',
  'contact.svc.8': 'Cooperative & Apartment Work',
  'contact.svc.9': 'Fire Systems',
  'contact.svc.10': 'Other',

  'reviews.badge': 'Customer Reviews',
  'reviews.title': 'What Do Our',
  'reviews.highlight': 'Customers Say?',
  'reviews.subtitle': 'Thousands of satisfied customers tell our story better than we can.',
  'reviews.stat.score': 'Average Score',
  'reviews.stat.clients': 'Happy Clients',
  'reviews.stat.satisfaction': 'Satisfaction',
  'reviews.cta': 'Join Our Satisfied Customers!',
  'review.1.name': 'Ahmet K.',
  'review.1.text': 'Master Engin and his team do their work on time and with precision. Friendly and reliable service! They handled the plumbing work perfectly.',
  'review.1.service': 'Sanitary Plumbing',
  'review.2.name': 'Fatma Ş.',
  'review.2.text': 'I had the boiler serviced and radiators cleaned, everything was done flawlessly and quickly. Their prices were very reasonable too, I definitely recommend them.',
  'review.2.service': 'Boiler Service',
  'review.3.name': 'Mehmet A.',
  'review.3.text': 'The water leak detection was done quickly and without issues, I definitely recommend them. They found it with non-destructive devices and intervened immediately.',
  'review.3.service': 'Fault Detection',
  'review.4.name': 'Zeynep T.',
  'review.4.text': 'They renovated my bathroom exactly as I wanted. They handled everything from gas connection onwards. Very satisfied!',
  'review.4.service': 'Bathroom Renovation',
  'review.5.name': 'İbrahim Y.',
  'review.5.text': 'They cleared all the drain blockages in our apartment building with machines in a short time. Professional team, masters who know their job.',
  'review.5.service': 'Drain Cleaning',

  'footer.desc': 'We work confidently with our friendly staff. The only address for quality. Professional plumbing services in Van and surrounding districts.',
  'footer.quickLinks': 'Quick Links',
  'footer.servicesTitle': 'Services',
  'footer.teamTitle': 'Our Masters',
  'footer.contactTitle': 'Contact & Location',
  'footer.link.home': 'Home',
  'footer.link.services': 'Our Services',
  'footer.link.about': 'About Us',
  'footer.link.booking': 'Book Appointment',
  'footer.svc.1': 'Sanitary Plumbing',
  'footer.svc.2': 'Natural Gas Installation',
  'footer.svc.3': 'Boiler Service',
  'footer.svc.4': 'Drain Cleaning',
  'footer.svc.5': 'Fire Systems',
  'footer.location': 'Van Center and Surrounding Districts, Turkey',
  'footer.hours': 'Every day 07:00 – 22:00',
  'footer.call': 'Call Now',
  'footer.wa': 'Write on WhatsApp',
  'footer.copyright': '© 2026 Vanpolat Tesisat. All rights reserved.',
  'footer.area': 'Professional plumbing services in Van and surrounding districts',

  'sp.hero.badge': 'Professional Plumbing Services',
  'sp.hero.title': 'Our Services',
  'sp.hero.sub': 'Van\'s reliable team for all your plumbing needs, from sanitary plumbing to natural gas, boiler service to fire systems.',
  'sp.grid.title': 'All',
  'sp.grid.highlight': 'Our Services',
  'sp.grid.subtitle': 'Our experienced masters are with you for every type of plumbing problem.',
  'sp.process.title': 'How Do',
  'sp.process.highlight': 'We Work?',
  'sp.process.subtitle': 'We solve your problem in 4 easy steps.',
  'sp.step.1.title': 'Call Us',
  'sp.step.1.desc': 'Notify your request via phone or WhatsApp.',
  'sp.step.2.title': 'On-Site Inspection',
  'sp.step.2.desc': 'Our master comes to your address and examines the situation.',
  'sp.step.3.title': 'Free Quote',
  'sp.step.3.desc': 'Presented to your approval with transparent pricing.',
  'sp.step.4.title': 'Work Completed',
  'sp.step.4.desc': 'Work is completed with guaranteed and meticulous craftsmanship.',

  'ap.hero.badge': 'About Us',
  'ap.hero.title': 'Vanpolat Tesisat Family',
  'ap.hero.sub': 'An experienced and honest plumbing team that has been serving as a family business in Van for years.',
  'ap.story.badge': 'Our Story',
  'ap.story.title': 'Van\'s Reliable Plumbing Family',
  'ap.story.p1': 'Vanpolat Tesisat is a family company that has been operating in Van for over 15 years. Our company, founded by Engin POLAT, now serves together with his brothers Hamza and Hayrullah.',
  'ap.story.p2': 'Our team, which provides quality workmanship in a wide range from sanitary plumbing to natural gas indoor installation, from boiler maintenance to professional drain cleaning services, puts customer satisfaction first in every project.',
  'ap.story.motto': '"We work with friendly staff. The only address for quality."',
  'ap.cert.1': 'Natural Gas Indoor Installation Certificate',
  'ap.cert.2': 'Sanitary Plumbing Authorization Certificate',
  'ap.cert.3': 'Occupational Safety Certificate',
  'ap.cert.4': 'Boiler Service Authorization',
  'ap.stat.1.value': '15+',
  'ap.stat.1.label': 'Years Experience',
  'ap.stat.2.value': '3',
  'ap.stat.2.label': 'Expert Masters',
  'ap.stat.3.value': '500+',
  'ap.stat.3.label': 'Completed Projects',
  'ap.stat.4.value': '100%',
  'ap.stat.4.label': 'Customer Satisfaction',
  'ap.values.badge': 'Our Values',
  'ap.values.title': 'Values That',
  'ap.values.highlight': 'Make Us Special',
  'val.1.title': 'Reliability',
  'val.1.desc': 'We do what we say. Every job is guaranteed and honest.',
  'val.2.title': 'Friendly Service',
  'val.2.desc': 'We always welcome our customers in a warm environment.',
  'val.3.title': 'Quality Workmanship',
  'val.3.desc': 'We do the job correctly and permanently the first time.',
  'val.4.title': 'On-Time Service',
  'val.4.desc': 'We stick to the agreed time, we value our customers\' time.',
  'ap.team.badge': 'Our Team',
  'ap.team.title': 'Meet',
  'ap.team.highlight': 'Our Masters',
  'ap.team.subtitle': 'The experienced, friendly and passionate Vanpolat team.',
  'ap.cta.title': 'I Have a Plumbing Problem, What Should I Do?',
  'ap.cta.sub': 'Call us now or write on WhatsApp — our friendly team will be there as soon as possible.',
  'ap.xp': 'Years Experience',

  'lang.tr': 'Türkçe',
  'lang.en': 'English',
  'lang.ar': 'العربية',
};
